/**
 * The Users page's breadcrumb, invite label and empty-state gate, derived from
 * the loaded data.
 */
import type { UserRow } from './userViewModel';
import type { useUsersPageData } from './useUsersPageData';

type UsersPageData = ReturnType<typeof useUsersPageData>;

export interface UsersPageChrome {
  crumb: string;
  inviteLabel: string;
  /** True when the viewer is alone in scope, so the empty state shows. */
  showEmpty: boolean;
  selfName: string;
}

export function selfDisplayName(
  self: { firstName: string | null; lastName: string | null; email: string } | null,
): string {
  if (!self) return 'You';
  const composed = `${self.firstName ?? ''} ${self.lastName ?? ''}`.trim();
  return composed || self.email;
}

export function usersPageChrome(
  data: Pick<UsersPageData, 'inScopeRows' | 'scopedRegionName' | 'self'>,
): UsersPageChrome {
  const activeInScope = data.inScopeRows.filter((r: UserRow) => r.status !== 'inactive').length;
  const firstRegion = data.self?.regions[0]?.region;
  return {
    crumb: `Settings · ${data.scopedRegionName ?? 'Bonsai Bar'}`,
    inviteLabel: data.scopedRegionName
      ? `Invite user to ${firstRegion?.code || firstRegion?.name || 'region'}`
      : 'Invite user',
    showEmpty: activeInScope <= 1,
    selfName: selfDisplayName(data.self),
  };
}
